import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
	server
} from '../../providers/http-service'
import util from '../../utils/util.js'
Vue.use(VueAxios, axios)
const state = {
	result: '',
	heList: [],
	hospitalParam: {},
	hosName: '',
}
const actions = {
	getHosDistrict({
		commit
	}, params) {
		server.getHosDistrict(params).then(res => {
			commit('setHosDistrict', res)
		})
	}

}
const mutations = {
	setHosDistrict(state, res) {
		state.result = res.result;
		state.heList = res.heList;
		state.hospitalParam = res.hospitalParam;
		state.hosName = util.normalString(res.hospitalParam.hospitalPreName) + util.normalString(res.hospitalParam.hospitalPostName)
	}
}
const getters = {
	itemsDis: state => {
		let heList = state.heList;
		if (heList == null) {
			// this.$router.push('/apply')
		} else {
			var heListArr = new Array();
			for (let i in heList) {
				var obj = new Object();
				obj.hosId = heList[i].hosId;
				obj.hosLogoUrl = heList[i].hosLogoUrl;
				obj.hosName = util.normalString(heList[i].hospitalPreName) + util.normalString(heList[i].hospitalPostName);
				obj.hBusinessLevelTwo = heList[i].hBusinessLevelTwo;
				obj.hBusinessLevelThree = heList[i].hBusinessLevelThree;
				obj.name = heList[i].name;
				obj.hosAddr = heList[i].hosAddr;
				heListArr.push(obj);
			}
			return heListArr;
		}
	}
}
export default {
	state,
	actions,
	mutations,
	getters
}
